module.exports = __webpack_public_path__ + "static/bg-d9f08696257b8374bd15d141f4dfb8e2.png";